import SubmissionStatus from '../Data/SubmissionStatus';
import { isAppointmentValid } from '../Hooks/useNavigation/useNavigation.helpers';
import { setPendingMoveForwards } from '../Lib/redux/slices/navigationControls';
import {
  setResubmit,
  setSubmissionStatus,
} from '../Lib/redux/slices/submission';
import { getSubmissionArgs } from './submission';
import {
  bookAppointmentAndSubmitLead,
  submitStandardLead,
} from './submitLead.helpers';

const submitLead = ({
  ancestorSid,
  bookedAppointmentId,
  campaignId,
  components,
  consentedLegalStatementHash,
  consentedSuppliersHash,
  countryCode,
  currentPage,
  dispatch,
  eventPublicKeyString,
  formId,
  iFrameId,
  isDomainInternal,
  isResubmission,
  localeCode,
  oneTrustLocale,
  pageUrl,
  parentPageCookies,
  phoneNumberCountryCode,
  referrerUrl,
  selectedAppointment,
  sourceSite,
  submissionPageNumber,
  submitLeadMutation,
  submitLeadWithAppointmentBookingMutation,
  testMode,
  useCidFromURL,
  widgetLabel,
  customerBrandMatches,
  subcategoryBrandMatches,
  multipleSupplierConsentedLegalStatementHash,
  singleSupplierConsentedLegalStatementHash,
  consentCertification,
  supplierId,
  visitorId,
  consentStatement,
  privacyPolicyUrl,
  subcategoryName,
  firstSubmissionAttemptTimestamp,
  subcategoryId,
  matchLevel,
  selectAndConnectBrand,
  supplierMatchSelectionEnabled,
}) => {
  dispatch(
    setSubmissionStatus({
      submissionStatus: SubmissionStatus.IN_PROGRESS,
    })
  );
  dispatch(setPendingMoveForwards({ isAwaitingAsyncRequest: true }));

  const isSelectedAppointmentValid = isAppointmentValid({
    appointment: selectedAppointment,
  });

  const submissionArgs = getSubmissionArgs({
    ancestorSid,
    campaignId,
    components,
    consentedLegalStatementHash,
    consentedSuppliersHash,
    countryCode,
    formId,
    phoneNumberCountryCode,
    sourceSite,
    testMode,
    pageUrl,
    referrerUrl,
    widgetLabel,
    useCidFromURL,
    parentPageCookies,
    oneTrustLocale,
    customerBrandMatches,
    subcategoryBrandMatches,
    multipleSupplierConsentedLegalStatementHash,
    singleSupplierConsentedLegalStatementHash,
    consentCertification,
    supplierId,
    consentStatement,
    privacyPolicyUrl,
    subcategoryName,
    subcategoryId,
    matchLevel,
    selectAndConnectBrand,
    supplierMatchSelectionEnabled,
  });

  if (!bookedAppointmentId && isSelectedAppointmentValid) {
    bookAppointmentAndSubmitLead({
      selectedAppointment,
      submissionArgs,
      dispatch,
      components,
      localeCode,
      submitLeadWithAppointmentBookingMutation,
      eventPublicKeyString,
      currentPage,
      iFrameId,
      isDomainInternal,
      formId,
      submissionPageNumber,
      isResubmission,
      visitorId,
      firstSubmissionAttemptTimestamp,
      selectAndConnectBrand,
    });
  } else {
    submitStandardLead({
      submitLeadMutation,
      submissionArgs,
      components,
      dispatch,
      currentPage,
      formId,
      eventPublicKeyString,
      iFrameId,
      isDomainInternal,
      submissionPageNumber,
      isResubmission,
      visitorId,
      firstSubmissionAttemptTimestamp,
      selectAndConnectBrand,
    });
  }

  dispatch(setResubmit({ shouldResubmit: false, replaceAncestorSid: false }));
};

export default submitLead;
